var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "seller"
  }, [_c('div', {
    staticClass: "seller__title"
  }, [_vm._v("\n    Продавец\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "seller__wrap"
  }, _vm._l(_vm.list, function (seller) {
    return _c('div', {
      key: seller.id,
      staticClass: "seller__item"
    }, [_c('RadioElement', {
      attrs: {
        "checked": "",
        "name": "seller-name"
      },
      on: {
        "change": function ($event) {
          return _vm.onSellerChange(seller);
        }
      }
    }, [_c('div', {
      staticClass: "seller__content"
    }, [seller.image ? _c('div', {
      staticClass: "seller__img-wrapper"
    }, [_c('img', {
      staticClass: "seller__img",
      attrs: {
        "src": seller.image,
        "alt": "seller__logo"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "seller__text-block"
    }, [_c('div', {
      staticClass: "seller__name"
    }, [_vm._v("\n              " + _vm._s(seller.name) + "\n            ")]), _vm._v(" "), seller.price ? _c('div', {
      staticClass: "seller__price"
    }, [_vm._v("\n              " + _vm._s(_vm.beautifyPrice(seller.price)) + "\n            ")]) : _vm._e(), _vm._v(" "), seller.period ? _c('span', {
      staticClass: "seller__text"
    }, [_vm._v(" Доставит через " + _vm._s(seller.period) + " ")]) : _vm._e()])])])], 1);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }